import store from '../store'
import {browserHistory} from 'react-router'

function loadData(url, postPayload) {

    const options = {
        headers: {
            'Accept': 'application/json',
            'morri-auth': store.getState().store.token || "",
            'epayslips-token': store.getState().store.oauth_token || ""
        }
    }


    if( postPayload ) {
        options.method = 'POST'
        options.body = JSON.stringify(postPayload)
        options.headers = { ...options.headers, "Content-Type": "application/json" }
    }


    return fetch(url,options).then((resp) => {
        const http_status = resp.status

        const white_list = {
            200: () => resp.json().then( (data) =>  ({...data, http_status })),
            201: () => resp.json().then( (data) =>  ({...data, http_status })),
            204: () => ({http_status}),
            404: () => ({http_status}),
            403: () => ({http_status}),
            412: () => ({http_status}),
            423: () => ({http_status})

        }

        if ( white_list[http_status] ) return white_list[http_status]()
        return {treat_as_error: true, http_status  }

    }).then((data) => {
        if( data.treat_as_error) throw data
        return  { treat_as_error: false, ...data }
    })
    .catch((error) => {
        browserHistory.push( "/error")
        console.log(`Error calling url: ${url}.  Responded with:`, error)
        throw error
        // return { treat_as_error: true, http_status: 501 }
    })

}


export function get(url) {
    return loadData(url)
}

export function post(url, postPayload ) {
    return loadData(url, postPayload )
}



// WEBPACK FOOTER //
// ./src/components/utils.js